import { UserService } from '@/api/services/userService';
import { TaxPayerService } from '@/api/services/taxPayerService';

export default {
  user: new UserService(),
  taxpayer: new TaxPayerService(),
};
